export default __webpack_public_path__ + "static/media/img (4).015b22dd.jpg";